import { Box, Grid, Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import TooltipCustomize from 'src/components/TooltipCustomize';
import BottomHeader from './Bottom';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import useQueryUrl from 'src/hooks/useQuery';

const HeaderWrapper = styled(Box)(
  ({ theme }) => `
    color: ${theme.header.textColor};
    padding: ${theme.spacing(1, 4, 0, 4)};
    right: 0;
    z-index: 5;
    box-shadow: ${theme.header.boxShadow};
    justify-content: space-between;
    width: 100%;
    background: ${theme.header.background};
    @media (min-width: ${theme.breakpoints.values.lg}px) {
        left: ${theme.sidebar.width};
        width: auto;
    }
`
);

function HeaderOfflineMedia() {
  const query = useQueryUrl();
  const typeQuery = query.get('type');
  const getTitle = () => {
    if (typeQuery === 'print') return 'Print Media Stream';
    if (typeQuery === 'broadcast') return 'Broadcast Media Stream';
    return 'Others Media Stream';
  };

  return (
    <HeaderWrapper display="flex" alignItems="center">
      <Grid container>
        <Grid item md={12}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Stack direction="row" alignItems="center">
              <Typography
                variant="h1"
                sx={{
                  mr: 1
                }}
              >
                {getTitle()}
              </Typography>
              <TooltipCustomize
                title={'List of all others media'}
                placement="top-start"
              >
                <InfoOutlinedIcon
                  fontSize="small"
                  sx={{ transform: 'translateY(-4px)' }}
                />
              </TooltipCustomize>
            </Stack>
          </Stack>
        </Grid>
        <Grid item md={12}>
          <BottomHeader />
        </Grid>
      </Grid>
    </HeaderWrapper>
  );
}

export default HeaderOfflineMedia;
